<template>
    <div class="link-slider-wrpper" ref="linkSliderWrpper">
        <div class="link-slider-group" ref="linkSliderGroup">
            <slot></slot>
        </div>
        <div class="link-slider-dots" v-show="!noDot">
            <span class="link-slider-dot" v-for="(item,index) in dots" :key="index"
                  :class="{'link-slider-dot-active' : currentPageIndex === index}" @click="goTo(index)"></span>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll';
    import {findComponentUpward} from "../../utils/dom";
    import {addClass} from "../../utils/dom";

    export default {
        name: "link-slider",
        props: {
            // 循环轮播
            loop: {
                type: Boolean,
                default: true
            },
            // 自动轮播
            autoPlay: {
                type: Boolean,
                default: true
            },
            // 间隔时间
            interval: {
                type: Number,
                default: 4000
            },
            // 是否显示dots
            noDot: {
                type: Boolean,
                default: false
            },
            // 显示第几张图片
            pageIndex: {
                type: [Number, String],
                default: 0
            }
        },
        data() {
            return {
                slider: null,
                dots: [],
                currentPageIndex: this.pageIndex
            }
        },
        watch: {
            pageIndex(val) {
                if (this.currentPageIndex !== val) {
                    this.currentPageIndex = val;
                }
            },
            currentPageIndex(val) {
                this.$emit('update:pageIndex', val);
            },
        },
        mounted() {
            // 为解决用display: none;方法隐藏的dom元素，无法通过offsetWidth获得父级元素宽度问题
            // 通过findComponentUpward方法，找到父级组件dialog的vue实例
            this.dialog = findComponentUpward(this, 'link-dialog');
            // 判断父级组件dialog是否存在，存在及监听组件的input方法，当input方法调用，就从新调用reset()的方法从新计算
            const next = () => {
                this.handleSetSliderWidth();
                this.handleInitDots();
                this.handleInitSlider();
                if (this.autoPlay) {
                    this.handlePlay();
                }
            };
            if (!!this.dialog) {
                this.onDialogChange = (val) => !!val && this.$nextTick(() => next())
                this.dialog.$on('input', this.onDialogChange)
            } else {
                next()
            }
            // 监听窗口变化事件，重新计算轮播尺寸
            window.addEventListener('resize', () => {
                if (!this.slider) {
                    return;
                }
                this.handleSetSliderWidth(true);
            });
        },
        beforeDestroy() {
            if (!!this.slider) {
                this.slider.destroy()
            }
            if (!!this.dialog) {
                this.dialog.$off('input', this.onDialogChange)
            }
        },
        methods: {
            /**
             * 设置轮播图组件的尺寸
             * @author  wangyue
             * @date    2018/12/4
             */
            handleSetSliderWidth(isResize) {
                if (!this.$refs.linkSliderGroup) {
                    return;
                }
                this.children = this.$refs.linkSliderGroup.children;
                let width = 0;
                let sliderWidth = this.$refs.linkSliderWrpper.clientWidth;
                for (let i = 0; i < this.children.length; i++) {
                    let child = this.children[i];
                    addClass(child, 'link-slider-item');
                    child.style.width = sliderWidth + 'px';
                    width += sliderWidth;
                }
                if (this.loop && !isResize) {
                    width += 2 * sliderWidth;
                }
                this.$refs.linkSliderGroup.style.width = width + 'px';
            },
            /**
             * 初始化better-scroll，并完成组件逻辑代码
             * @author  wangyue
             * @date    2018/12/4
             */
            handleInitSlider() {
                this.slider = new BScroll(this.$refs.linkSliderWrpper, {
                    scrollX: true,
                    scrollY: false,
                    momentum: false,
                    snap: true,
                    snapLoop: this.loop,
                    snapThreshold: 0.3,
                    snapSpeed: 400
                });
                // 判断是否从首张图片开始轮播，定位在设置图片开始
                this.pageIndex !== 0 && this.slider.goToPage(this.pageIndex + 1, 0, 0);
                !!this.dialog && this.slider.goToPage(this.pageIndex, 0, 0);
                !!this.dialog && (this.currentPageIndex = this.pageIndex);
                // 监听better-scroll的滑动结束事件，实现自动轮播
                this.slider.on('scrollEnd', () => {
                    let pageIndex = this.slider.getCurrentPage().pageX;
                    if (this.loop) {
                        pageIndex -= 1;
                    }
                    this.currentPageIndex = pageIndex;
                    if (this.autoPlay) {
                        clearTimeout(this.timer);
                        this.handlePlay();
                    }
                });
            },
            /**
             * 生成轮播下方dots小导航
             * @author  wangyue
             * @date    2018/12/4
             */
            handleInitDots() {
                this.dots = new Array(this.children.length);
            },
            /**
             * 自动轮播函数
             * @author  wangyue
             * @date    2018/12/4
             */
            handlePlay() {
                let pageIndex = this.currentPageIndex + 1;
                if (this.loop) {
                    pageIndex += 1;
                }
                this.timer = setTimeout(() => {
                    this.slider.goToPage(pageIndex, 0, 400);
                }, this.interval);
            },
            /**
             * 跳转上一张图片
             * @author  wangyue
             * @date    2018/12/5
             */
            gotoPrev() {
                this.slider.prev(400);
            },
            /**
             * 跳转下一张图片
             * @author  wangyue
             * @date    2018/12/5
             */
            gotoNext() {
                this.slider.next(400);
            },
            /**
             * 跳转某一张图片
             * @author  wangyue
             * @date    2018/12/5
             */
            goTo(val) {
                let num = val;
                this.loop ? num += 1 : num;
                this.slider.goToPage(num, 0, 400);
            }
        }
    }
</script>

<style lang="scss">
    .link-slider-wrpper {
        position: relative;
        min-height: 1px;
        overflow: hidden;

        .link-slider-group {
            position: relative;
            overflow: hidden;
            white-space: nowrap;

            .link-slider-item {
                float: left;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                overflow: hidden;
                text-align: center;

                a {
                    display: block;
                    width: 100%;
                    overflow: hidden;
                    text-decoration: none;
                }

                img {
                    display: block;
                    width: auto;
                    max-height: 80%;
                }
            }
        }

        .link-slider-dots {
            position: absolute;
            right: 0;
            left: 0;
            bottom: 24px;
            text-align: center;
            font-size: 0;

            .link-slider-dot {
                display: inline-block;
                margin: 0 4px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: rgba(255, 255, 255, 0.5);
                cursor: pointer;

                &.link-slider-dot-active {
                    width: 20px;
                    border-radius: 5px;
                    background: rgba(255, 255, 255, 1);
                }
            }
        }
    }
</style>
